import { NestAPI } from '@marketing-milk/frontend'
import { CreativeImportEditState } from '@marketing-milk/interfaces'

/**
 * CR: one-shot fetch of the pre-confirm edit state for reopening an
 * awaiting_confirmation import. Reconstructs the Review report + saved
 * selection + sprint from the persisted job/rows.
 */
export const fetchCreativeImportEditState = async (
  businessID: number | string,
  creativeImportID: number
): Promise<CreativeImportEditState> => {
  const response = await NestAPI.get<CreativeImportEditState>(
    `businesses/${businessID}/creative-import/${creativeImportID}/edit-state`
  )
  return response.data
}
